(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-benefits-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quality-feature-carousel')) {
    customElements.define('quality-feature-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-qfc-track]');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('[data-qfc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-qfc-dot]'));
        this.status = this.querySelector('[data-qfc-status]');
        this.index = 0;
        this.controller = new AbortController();
        const signal = this.controller.signal;

        const previous = this.querySelector('[data-qfc-prev]');
        const next = this.querySelector('[data-qfc-next]');
        if (this.slides.length > 1) {
          [previous, next, this.querySelector('[data-qfc-dots]')].forEach(element => {
            if (element) element.hidden = false;
          });
          previous.addEventListener('click', () => this.goTo(this.index - 1), { signal });
          next.addEventListener('click', () => this.goTo(this.index + 1), { signal });
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), { signal }));
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
            let target;
            if (event.key === 'ArrowLeft') target = this.index - 1;
            else if (event.key === 'ArrowRight') target = this.index + 1;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = this.slides.length - 1;
            else return;
            event.preventDefault();
            this.goTo(target);
          }, { signal });
        }

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            const width = this.track.clientWidth;
            if (!width) return;
            this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
            this.updateControls(true);
          }, 100);
        }, { passive: true, signal });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, false);
        }, { signal });

        if ('ResizeObserver' in window) {
          this.lastWidth = this.track.clientWidth;
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.track.clientWidth;
            if (width && width !== this.lastWidth) {
              this.lastWidth = width;
              this.goTo(this.index, false);
            }
          });
          this.resizeObserver.observe(this.track);
        }
        this.goTo(0, false);
      }

      goTo(index, animate = true) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: animate && !reduceMotion ? 'smooth' : 'instant'
        });
        this.updateControls(animate);
      }

      updateControls(announce) {
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        if (announce && this.status) {
          const title = this.slides[this.index].querySelector('.qfc-slide-title');
          this.status.textContent = 'Image ' + (this.index + 1) + ' of ' + this.slides.length + (title ? ': ' + title.textContent.trim() : '');
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.scrollTimer);
        if (this.controller) this.controller.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function setupCartDrawerTrigger(header) {
    const cartLink = header.querySelector('[data-cart-drawer-trigger]');

    if (!cartLink || cartLink.dataset.cartDrawerTriggerBound === 'true') return;

    cartLink.dataset.cartDrawerTriggerBound = 'true';
    cartLink.addEventListener('click', (event) => {
      // The drawer already handles clicks inside #cart-icon-bubble.
      if (event.defaultPrevented) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

      event.preventDefault();
      cartDrawer.open(cartLink);
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leak-repair-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('leak-repair-section')) {
    customElements.define(
      'leak-repair-section',
      class extends HTMLElement {

        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.controller) return;

          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];

          if (!this.track || this.slides.length < 2) return;

          this.controller = new AbortController();

          const on = (target, event, handler) => {
            if (target) {
              target.addEventListener(event, handler, {
                signal: this.controller.signal
              });
            }
          };

          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.playButton = this.querySelector('[data-play]');
          this.reducedMotion = matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.index = 0;
          this.visible = true;
          this.hovered = false;
          this.selected = false;
          this.dragging = false;
          this.scrolling = false;

          this.playing =
            this.dataset.autoplay === 'true' &&
            !this.reducedMotion.matches;

          this.querySelector('[data-controls]').hidden = false;

          on(
            this.querySelector('[data-prev]'),
            'click',
            () => this.go(this.index - 1)
          );

          on(
            this.querySelector('[data-next]'),
            'click',
            () => this.go(this.index + 1)
          );

          this.dots.forEach((dot, index) => {
            on(dot, 'click', () => this.go(index));
          });

          on(this.playButton, 'click', () => {
            this.playing = !this.playing;
            this.update();
          });

          on(this, 'pointerenter', (event) => {
            if (event.pointerType === 'mouse') {
              this.hovered = true;
            }
          });

          on(this, 'pointerleave', () => {
            this.hovered = false;
          });

          on(this.track, 'pointerdown', () => {
            this.dragging = true;
          });

          on(document, 'pointerup', () => {
            this.dragging = false;
          });

          on(document, 'pointercancel', () => {
            this.dragging = false;
          });

          on(this.track, 'keydown', (event) => {
            if (
              !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(
                event.key
              )
            ) {
              return;
            }

            event.preventDefault();

            let next =
              this.index +
              (event.key === 'ArrowLeft' ? -1 : 1);

            if (event.key === 'Home') {
              next = 0;
            }

            if (event.key === 'End') {
              next = this.slides.length - 1;
            }

            this.go(next);
          });

          on(this.track, 'scroll', () => {
            this.scrolling = true;
            clearTimeout(this.scrollTimer);

            this.scrollTimer = setTimeout(() => {
              this.index = this.slides.reduce(
                (best, slide, index) => {
                  const distance = Math.abs(
                    slide.offsetLeft - this.track.scrollLeft
                  );

                  const previous = Math.abs(
                    this.slides[best].offsetLeft -
                    this.track.scrollLeft
                  );

                  return distance < previous ? index : best;
                },
                0
              );

              this.scrolling = false;
              this.update();
            }, 120);
          });

          on(document, 'shopify:block:select', (event) => {
            if (
              event.detail.sectionId !== this.dataset.sectionId
            ) {
              return;
            }

            const index = this.slides.findIndex(
              slide =>
                slide.dataset.blockId === event.detail.blockId
            );

            if (index !== -1) {
              this.selected = true;
              this.go(index, false);
            }
          });

          [
            'shopify:section:select',
            'shopify:section:deselect',
            'shopify:block:deselect'
          ].forEach(eventName => {
            on(document, eventName, (event) => {
              if (
                event.detail.sectionId === this.dataset.sectionId
              ) {
                this.selected =
                  eventName === 'shopify:section:select';
              }
            });
          });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.go(this.index, false);
            });

            this.resizeObserver.observe(this.track);
          }

          if ('IntersectionObserver' in window) {
            this.visibilityObserver = new IntersectionObserver(
              entries => {
                this.visible = entries[0].isIntersecting;
              }
            );

            this.visibilityObserver.observe(this.track);
          }

          if (this.dataset.autoplay === 'true') {
            this.timer = setInterval(() => {
              if (
                !this.playing ||
                this.hovered ||
                this.selected ||
                this.dragging ||
                this.scrolling ||
                !this.visible ||
                document.hidden ||
                this.matches(':focus-within') ||
                this.reducedMotion.matches
              ) {
                return;
              }

              this.go(this.index + 1);
            }, Math.max(3000, Number(this.dataset.delay) || 5000));
          }

          this.update();
        }

        go(index, animate = true) {
          this.index =
            (index + this.slides.length) % this.slides.length;

          this.track.scrollTo({
            left: this.slides[this.index].offsetLeft,
            behavior:
              animate && !this.reducedMotion.matches
                ? 'smooth'
                : 'auto'
          });

          this.update();
        }

        update() {
          this.dots.forEach((dot, index) => {
            if (index === this.index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.slides.forEach((slide, index) => {
            slide.setAttribute(
              'aria-hidden',
              String(index !== this.index)
            );
          });

          if (this.playButton) {
            this.playButton.textContent =
              this.playing ? 'Pause' : 'Play';

            this.playButton.setAttribute(
              'aria-label',
              this.playing
                ? 'Pause automatic slideshow'
                : 'Start automatic slideshow'
            );
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          clearInterval(this.timer);
          clearTimeout(this.scrollTimer);

          if (this.controller) {
            this.controller.abort();
          }

          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }

          if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
          }

          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pomade-style-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pomade-style-gallery-v2')) return;
    class PomadeStyleGallery extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (this.initialized || !this.isConnected) return;
        this.viewport = this.querySelector('[data-viewport]');
        if (!this.viewport) return;
        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.dots = this.querySelector('[data-dots]');
        this.toggle = this.querySelector('[data-autoplay-toggle]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.listeners = [];
        this.positions = [];
        this.index = 0;
        this.inView = true;
        this.hovered = false;
        this.focused = false;
        this.drag = null;
        this.interacting = false;
        this.userPaused = false;
        this.editorSelected = false;
        this.autoplay = this.dataset.autoplay !== 'false';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.delay = Math.max(2000, Number(this.dataset.delay) || 4000);
        this.listen(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1));
        this.listen(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1));
        this.listen(this.dots, 'click', (event) => {
          const dot = event.target.closest('[data-position]');
          if (dot) this.go(Number(dot.dataset.position));
        });
        this.listen(this.toggle, 'click', () => {
          this.userPaused = !this.userPaused;
          if (!this.userPaused) this.focused = false;
          this.updateToggle();
          this.schedule();
        });
        this.listen(this.viewport, 'scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.sync());
        }, { passive: true });
        this.listen(this.viewport, 'keydown', (event) => {
          if (event.target !== this.viewport) return;
          const actions = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.positions.length - 1 };
          if (Object.prototype.hasOwnProperty.call(actions, event.key)) {
            event.preventDefault();
            this.go(actions[event.key]);
          }
        });
        this.listen(this, 'mouseenter', () => { this.hovered = this.pauseOnHover; this.schedule(); });
        this.listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        this.listen(this, 'focusin', (event) => {
          this.focused = Boolean(event.target && event.target.matches && event.target.matches(':focus-visible'));
          this.schedule();
        });
        this.listen(this, 'focusout', (event) => {
          const target = event.relatedTarget;
          this.focused = Boolean(target && this.contains(target) && target.matches && target.matches(':focus-visible'));
          this.schedule();
        });
        this.listen(document, 'visibilitychange', () => this.schedule());
        this.listen(this.reducedMotion, 'change', () => { this.updateToggle(); this.schedule(); });
        this.listen(this.viewport, 'pointerdown', (event) => {
          this.interacting = true;
          this.schedule();
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft };
          this.viewport.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
          event.preventDefault();
        });
        this.listen(this.viewport, 'pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          this.viewport.scrollLeft = this.drag.left - (event.clientX - this.drag.x);
        });
        const finish = (event) => {
          const wasDragging = this.drag && this.drag.id === event.pointerId;
          this.drag = null;
          this.interacting = false;
          this.viewport.classList.remove('is-dragging');
          if (wasDragging) {
            if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
            this.sync();
            this.go(this.index);
          }
          this.schedule();
        };
        this.listen(this.viewport, 'pointerup', finish);
        this.listen(this.viewport, 'pointercancel', finish);
        this.listen(this, 'shopify:block:select', (event) => {
          this.editorSelected = true;
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(Math.min(index, this.positions.length - 1), false);
          this.schedule();
        });
        this.listen(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
        this.listen(document, 'shopify:section:load', (event) => {
          if (event.target && event.target.contains(this)) this.measure();
        });
        this.listen(window, 'pageshow', () => this.measure());
        this.measure();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.measure());
          });
          this.resizeObserver.observe(this.viewport);
        } else {
          this.listen(window, 'resize', () => this.measure());
        }
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.schedule();
          });
          this.intersectionObserver.observe(this);
        }
      }
      listen(target, type, handler, options) {
        if (!target) return;
        target.addEventListener(type, handler, options);
        this.listeners.push(() => target.removeEventListener(type, handler, options));
      }
      measure() {
        const visible = Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--ps-visible'), 10) || 2);
        const maxIndex = Math.max(0, this.cards.length - visible);
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const first = this.cards.length ? this.cards[0].offsetLeft : 0;
        this.positions = this.cards.length ? Array.from({ length: maxIndex + 1 }, (_, i) => Math.min(this.cards[i].offsetLeft - first, maxScroll)) : [];
        this.index = Math.min(this.index, Math.max(0, this.positions.length - 1));
        this.dots.replaceChildren();
        this.positions.forEach((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ps-dot';
          button.dataset.position = String(index);
          button.setAttribute('aria-label', 'Go to style group ' + (index + 1));
          button.setAttribute('aria-controls', this.viewport.id);
          button.appendChild(document.createElement('span'));
          this.dots.appendChild(button);
        });
        const canSlide = this.positions.length > 1 && maxScroll > 1;
        this.querySelector('[data-arrows]').hidden = this.cards.length < 2;
        this.querySelector('[data-prev]').disabled = !canSlide;
        this.querySelector('[data-next]').disabled = !canSlide;
        this.querySelector('[data-pagination]').hidden = !canSlide;
        this.updateToggle();
        this.viewport.scrollTo({ left: this.positions[this.index] || 0, behavior: 'auto' });
        this.sync();
        this.schedule();
      }
      sync() {
        if (!this.positions.length) return;
        const left = this.viewport.scrollLeft;
        this.index = this.positions.reduce((best, position, index) => Math.abs(position - left) < Math.abs(this.positions[best] - left) ? index : best, 0);
        Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      }
      go(index, smooth = true) {
        if (!this.positions.length) return;
        const target = (index + this.positions.length) % this.positions.length;
        this.index = target;
        this.viewport.scrollTo({ left: this.positions[target], behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'auto' });
        Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === target)));
        this.schedule();
      }
      updateToggle() {
        const paused = this.userPaused || this.reducedMotion.matches;
        this.toggle.hidden = !this.autoplay || this.positions.length < 2 || this.reducedMotion.matches;
        this.toggle.setAttribute('aria-label', paused ? 'Play automatic slideshow' : 'Pause automatic slideshow');
        this.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
        this.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.autoplay || this.userPaused || this.reducedMotion.matches || this.positions.length < 2 || !this.inView || this.hovered || this.focused || this.interacting || this.editorSelected || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.timer);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.listeners) this.listeners.forEach((remove) => remove());
        this.initialized = false;
      }
    }
    customElements.define('pomade-style-gallery-v2', PomadeStyleGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restored-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restored-comparison')) {
    customElements.define('restored-comparison', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.pointer = null;
      }

      initialize() {
        if (this.events) this.events.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-rc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-rc-go]'));
        this.status = this.querySelector('[data-rc-status]');
        this.index = Math.max(0, Math.min(this.index || 0, this.slides.length - 1));
        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-rc-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-rc-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.go(index), options);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
          this.pointer = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            slide: this.slides.indexOf(event.target.closest('[data-rc-slide]'))
          };
          this.track.setPointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointerup', (event) => {
          const start = this.pointer;
          if (!start || start.id !== event.pointerId) return;
          this.pointer = null;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.go(this.index + (dx < 0 ? 1 : -1));
          } else if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && start.slide >= 0) {
            this.go(start.slide);
          }
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.track.addEventListener('lostpointercapture', () => { this.pointer = null; }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.go(selected);
        }, options);

        this.go(this.index, false);
        this.classList.add('is-ready');
      }

      go(index, announce = true) {
        const count = this.slides.length;
        if (!count) return;
        this.index = ((index % count) + count) % count;

        this.slides.forEach((slide, position) => {
          let offset = (position - this.index + count) % count;
          if (offset > count / 2) offset -= count;
          const active = offset === 0;
          slide.style.setProperty('--rc-shift', (offset * 85) + '%');
          slide.style.setProperty('--rc-scale', active ? '1' : '0.8');
          slide.style.zIndex = active ? '10' : '1';
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-neighbor', Math.abs(offset) === 1);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.dots.forEach((dot, position) => {
          dot.setAttribute('aria-current', position === this.index ? 'true' : 'false');
        });
        if (announce && this.status) {
          this.status.textContent = 'Comparison ' + (this.index + 1) + ' of ' + count;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rust-repair-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rust-repair-faq')) {
    customElements.define('rust-repair-faq', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify || !window.Shopify.designMode || this.onBlockSelect) return;
        this.onBlockSelect = (event) => {
          const item = event.target.closest('details.rf-item');
          if (item && this.contains(item)) item.open = true;
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (!this.onBlockSelect) return;
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.onBlockSelect = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-results-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('salon-results-section')) {
    customElements.define('salon-results-section', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        if (this.events) this.events.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      initialize() {
        if (this.events) this.events.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-sr-track]');
        this.slides = Array.from(this.querySelectorAll('[data-sr-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-sr-dot]'));
        this.status = this.querySelector('[data-sr-status]');
        this.index = Math.max(0, Math.min(this.index || 0, this.slides.length - 1));

        this.querySelectorAll('[data-sr-range]').forEach((range) => {
          const update = () => {
            const value = Math.max(0, Math.min(100, Number(range.value)));
            range.closest('[data-sr-slide]').style.setProperty('--sr-position', value + '%');
            range.setAttribute('aria-valuetext', range.dataset.beforeLabel + ' ' + value + '%, ' + range.dataset.afterLabel + ' ' + (100 - value) + '%');
          };
          update();
          range.addEventListener('input', update, options);
        });
        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-sr-prev]').addEventListener('click', () => this.navigate(this.index - 1), options);
        this.querySelector('[data-sr-next]').addEventListener('click', () => this.navigate(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.navigate(index), options));

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const origin = this.slides[0].offsetLeft;
            let nearest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, index) => {
              const delta = Math.abs(slide.offsetLeft - origin - this.track.scrollLeft);
              if (delta < distance) { distance = delta; nearest = index; }
            });
            this.updateNavigation(nearest, false);
          });
        }, { ...options, passive: true });

        this.track.addEventListener('focusin', (event) => {
          const slide = event.target.closest('[data-sr-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0 && index !== this.index) this.navigate(index, false, false);
        }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.navigate(index, false);
        }, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.navigate(this.index, false, false));
          this.resizeObserver.observe(this.track);
        }
        this.navigate(this.index, false, false);
        this.classList.add('is-ready');
      }

      navigate(index, smooth = true, announce = true) {
        const count = this.slides.length;
        if (!count) return;
        const target = ((index % count) + count) % count;
        const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left, behavior: smooth && !reduced ? 'smooth' : 'auto' });
        this.updateNavigation(target, announce);
      }

      updateNavigation(index, announce) {
        this.index = index;
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', position === index ? 'true' : 'false'));
        if (announce && this.status) {
          this.status.textContent = 'Comparison ' + (index + 1) + ' of ' + this.slides.length;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-scents-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scent-note-carousel')) {
    customElements.define('scent-note-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('[data-viewport]');
        if (!this.track || !this.viewport) return;
        this.track.querySelectorAll('[data-clone]').forEach(node => node.remove());
        this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
        this.count = this.slides.length;
        if (!this.count) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');
        this.busy = false;
        this.pointer = null;
        this.suppressClick = false;

        if (this.count > 1) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          this.slides.forEach(slide => {
            const makeClone = () => {
              const clone = slide.cloneNode(true);
              clone.setAttribute('data-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-block-id');
              [clone, ...clone.querySelectorAll('*')].forEach(node => {
                node.removeAttribute('id');
                Array.from(node.attributes).forEach(attribute => {
                  if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
                });
              });
              return clone;
            };
            before.append(makeClone());
            after.append(makeClone());
          });
          this.track.prepend(before);
          this.track.append(after);
        }
        this.cells = Array.from(this.track.children);
        this.position = this.count > 1 ? this.count : 0;
        this.classList.add('is-ready');
        this.place(false);

        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); return; }
          if (event.target.closest('[data-prev]')) this.move(this.position - 1);
          else if (event.target.closest('[data-next]')) this.move(this.position + 1);
          else if (event.target.closest('[data-dot]')) this.goTo(Number(event.target.closest('[data-dot]').dataset.dot));
          else {
            const cell = event.target.closest('[data-slide]');
            if (cell && this.track.contains(cell)) this.move(this.cells.indexOf(cell));
          }
        }, options);

        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport || this.count < 2) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.count - 1);
          else this.move(this.position + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        this.track.addEventListener('transitionend', event => {
          if (event.target === this.track && event.propertyName === 'transform') this.finish();
        }, options);
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);

        this.viewport.addEventListener('pointerdown', event => {
          if (this.count < 2 || this.busy || !event.isPrimary || event.button !== 0) return;
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false, vertical: false };
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId || pointer.vertical) return;
          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;
          if (!pointer.horizontal && Math.max(Math.abs(dx), Math.abs(dy)) > 8) {
            if (Math.abs(dy) > Math.abs(dx)) { pointer.vertical = true; return; }
            pointer.horizontal = true;
            this.viewport.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
          }
          if (pointer.horizontal) {
            event.preventDefault();
            this.track.style.transition = 'none';
            this.track.style.transform = `translate3d(${this.offset + dx}px,0,0)`;
          }
        }, options);
        const endPointer = event => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;
          this.pointer = null;
          this.classList.remove('is-dragging');
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          if (!pointer.horizontal) return;
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 250);
          const dx = event.clientX - pointer.x;
          if (event.type !== 'pointercancel' && Math.abs(dx) > 40) this.move(this.position + (dx < 0 ? 1 : -1));
          else this.place(true);
        };
        this.viewport.addEventListener('pointerup', endPointer, options);
        this.viewport.addEventListener('pointercancel', endPointer, options);

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
          if (index < 0) return;
          clearTimeout(this.endTimer);
          this.busy = false;
          this.position = this.count > 1 ? this.count + index : 0;
          this.place(false);
        }, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.finish());
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.finish(), options);
        }
      }

      realIndex() { return ((this.position % this.count) + this.count) % this.count; }

      place(animate) {
        const cell = this.cells[this.position];
        if (!cell) return;
        this.offset = this.viewport.clientWidth / 2 - cell.offsetLeft - cell.offsetWidth / 2;
        const useAnimation = animate && !this.reducedMotion.matches;
        this.classList.toggle('is-instant', !useAnimation);
        this.track.style.transition = useAnimation ? 'transform 420ms ease' : 'none';
        this.track.style.transform = `translate3d(${this.offset}px,0,0)`;
        this.cells.forEach((node, index) => node.classList.toggle('is-active', index === this.position));
        const active = this.realIndex();
        this.dots.forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.status) this.status.textContent = `${active + 1} / ${this.count}`;
        if (useAnimation) {
          this.busy = true;
          clearTimeout(this.endTimer);
          this.endTimer = setTimeout(() => this.finish(), 480);
        }
      }

      move(position) {
        if (this.count < 2 || this.busy || position < 0 || position >= this.cells.length) return;
        this.position = position;
        this.place(true);
        if (this.reducedMotion.matches) this.finish();
      }

      goTo(index) {
        if (this.count < 2 || this.busy) return;
        const candidates = [index, index + this.count, index + this.count * 2];
        candidates.sort((a, b) => Math.abs(a - this.position) - Math.abs(b - this.position));
        this.move(candidates[0]);
      }

      finish() {
        clearTimeout(this.endTimer);
        this.busy = false;
        if (!this.cells || !this.isConnected) return;
        this.position = this.count > 1 ? this.count + this.realIndex() : 0;
        this.place(false);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.endTimer);
        clearTimeout(this.clickTimer);
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.querySelectorAll('[data-clone]').forEach(node => node.remove());
        this.classList.remove('is-ready', 'is-dragging', 'is-instant');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
